export default __webpack_public_path__ + "static/media/img-v3-launching.3bac9423.png";